import React, { useEffect, useState, useCallback } from "react";
import apiClient from "../../../utils/apiClient";
import DynamicRegimeConfigDataTable from "./DynamicRegimeConfigDataTable";
import server from "../../../utils/serverConfig";

export default function DynamicRegimeConfig({ tableName = "nifty_regime_grid", displayName = "Nifty Regime" }) {
  const [regimeConfigData, setRegimeConfigData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const fetchRegimeConfigData = useCallback(() => {
    if (!tableName) return;
    setIsLoading(true);
    const config = {
      method: "GET",
      url: `${server.godseye.baseUrl}get-regime-grid-data?table_name=${tableName}`,
    };

    apiClient
      .request(config)
      .then((response) => {
        setRegimeConfigData(response.data.data || []);
        setIsLoading(false);
      })
      .catch((error) => {
        console.error(`Error fetching regime grid data for ${tableName}:`, error);
        setIsLoading(false);
      });
  }, [tableName]);

  const handleEditLotConfig = (rowData, lotConfig) => {
    const config = {
      method: "POST",
      url: `${server.godseye.baseUrl}update-regime-grid-data`,
      data: {
        table_name: tableName,
        strategy: rowData?.strategy,
        underlying: rowData?.underlying,
        option_type: rowData?.option_type,
        symbol: rowData?.symbol,
        lot_config: lotConfig,
      },
    };

    apiClient
      .request(config)
      .then(() => {
        fetchRegimeConfigData();
      })
      .catch((error) => {
        console.error(`Error updating regime grid data for ${tableName}:`, error);
      });
  };

  useEffect(() => {
    fetchRegimeConfigData();
  }, [fetchRegimeConfigData]);

  return (
    <div className="flex flex-col relative w-full max-h-screen">
      <div className="flex items-center justify-between space-x-4">
        <div className="flex justify-between items-center h-[40px] px-6 w-full">
          <p className="flex items-center text-lg font-semibold text-white">
            {displayName} Config
          </p>
        </div>
      </div>

      <div className="flex h-full flex-col relative w-full">
        {isLoading ? (
          <div className="flex items-center justify-center text-[20px] text-white font-medium w-full h-[calc(100vh-210px)]">
            loading....
          </div>
        ) : !isLoading && regimeConfigData.length === 0 ? (
          <div className="flex items-center justify-center text-[20px] text-white font-medium w-full h-[calc(100vh-210px)]">
            No Data Found
          </div>
        ) : (
          <div className="flex min-w-full pt-2">
            <DynamicRegimeConfigDataTable
              regimeConfigData={regimeConfigData}
              displayName={displayName}
              handleEditLotConfig={handleEditLotConfig}
            />
          </div>
        )}
      </div>
    </div>
  );
}
